import React, { Component, createRef } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import { isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import { getClientList, getClientRecentActivities, getClientUpcomingActivities } from "../../store/clients/actions"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Offcanvas, OffcanvasHeader, OffcanvasBody,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent, TabPane, FormGroup, Label,
  CardHeader
} from "reactstrap"
import classnames from "classnames"
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RsAdNew from "components/buttons/Adnew";
import RsLink from "components/buttons/rsLink";
import RsCardImg from "components/Rscards/Rscard-img";
import ClientCreate from "./forms/create-client"
import upcomingImg from "../../assets/img/upcoming.png"
import interactionImg from "../../assets/img/interactions.png"
import activeClient from "../../assets/img/add-contact.png"
import forcastRevenue from "../../assets/img/forecast-analytics.png"
import performanceGoals from "../../assets/img/performance-client.png"
import ClientPageMenu from "./menu/all-client"
import { toast, ToastContainer } from "react-toastify";
import RsCard from "components/Rscards/Rscard";
import RSPieChart from "components/charts/RSPieChart";
import RSBarChart from "components/charts/RSBarChart";
import ColumnWithDataLabels from "pages/Contacts/ColumnWithDataLabels";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { API_URL } from "helpers/app_url";
import axios from "axios";
import ActionRefferal from "components/buttons/actionRefferal";
import SaveButton from "components/buttons/save";
import activeClientIcon from "../../assets/img/user-icon.png"
import closingIcon from "../../assets/img/closing-icon.png"
import performanceIcon from "../../assets/img/performance-icon.png"
import conversionIcon from "../../assets/img/conversion-icon.png"
import RsAdNewV2 from "components/buttons/Adnew-v2";
import RsCardImgv2 from "components/Rscards/Rscard-imgv2";
import CopyText from "components/buttons/copyBtn";
import moment from "moment";
import RsCardImgv4 from "components/Rscards/Rscard-imgv4";
import { MultiSelect } from 'primereact/multiselect';
import SafeField from "helpers/SafeField";
class Client extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeRef: "1",
      activeTab: '1',
      expandedRows: null,
      reports: [
        { title: "Active clients", iconClass: activeClientIcon, description: "loading...." },
        { title: "Closing(s) this month", iconClass: closingIcon, description: "loading....", },
        //{ title: "Performance / Goals", iconClass: performanceIcon, description: "loading...." },
        { title: "Lead to client conversion", iconClass: conversionIcon, description: "loading...." },
      ],
    }
    this.toggleAddNew = this.toggleAddNew.bind(this);
    this.toggleClosing = this.toggleClosing.bind(this);
    this.referralCanavas = this.referralCanavas.bind(this);
    this.dt = createRef();
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }
  toggleClosing() {
    this.setState({ isClosing: !this.state.isClosing });
    this.fetchMonthClosings();
  }
  toggleAddNew() {
    this.setState({ isAddNew: !this.state.isAddNew });
  }
  toggleReferral() {
    this.setState({ isReferral: !this.state.isReferral });
  }

  referralCanavas = arg => {
    const clientRef = arg;
    this.setState({
      clientRef: {
        id: clientRef.id,
        email: clientRef.email,
        mobile: clientRef.mobile
      },
    });
    this.fetchReferralRequestEmail(clientRef.id);
    this.fetchReviewsRequestEmail(clientRef.id);
    this.fetchSurveyRequestEmail(clientRef.id);
    this.fetchAllReferral(clientRef.id);
    this.fetchReferralHistory(clientRef.id)
    this.fetchSurveyHistory(clientRef.id)
    this.toggleReferral();
  }

  toggleReff(tab) {
    if (this.state.activeRef !== tab) {
      this.setState({
        activeRef: tab,
      });
    }
  }

  fetchReferralRequestEmail = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      AgentId: agentId,
      ClientId: ContactId
    };

    axios.get(`${API_URL}SystemNotificationTemplate/getagentreferraltemplatebyclient`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const emailContent = res.data || '';
      this.setState({ emailContent: emailContent, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching worksheet email content:", error);
        this.setState({ isLoading: false });
      });
  };
  fetchAllReferral = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      agentId: agentId,
      contactId: ContactId
    };

    axios.get(`${API_URL}Lead/allforclient`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const allreferrals = res.data || '';
      this.setState({ allreferrals: allreferrals, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching  content:", error);
        this.setState({ isLoading: false });
      });
  };
  fetchReviewsRequestEmail = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      AgentId: agentId,
      ClientId: ContactId
    };

    axios.get(`${API_URL}SystemNotificationTemplate/getagentreviewtemplatebyclient`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const reviewemailContent = res.data || '';
      this.setState({ reviewemailContent: reviewemailContent, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching worksheet email content:", error);
        this.setState({ isLoading: false });
      });
  };

  fetchSurveyRequestEmail = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      AgentId: agentId,
      ClientId: ContactId
    };

    axios.get(`${API_URL}SystemNotificationTemplate/getagentsurveytemplatebyclient`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const surveyemailContent = res.data || '';
      this.setState({ surveyemailContent: surveyemailContent, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching worksheet email content:", error);
        this.setState({ isLoading: false });
      });
  };

  fetchReferralHistory = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      agentId: agentId,
      clientId: ContactId
    };

    axios.get(`${API_URL}ContactConnect/allforclient`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const allHistory = res.data || '';
      this.setState({ allHistory: allHistory, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching  content:", error);
        this.setState({ isLoading: false });
      });
  };
  componentDidMount() {
    const { onGetClientLists, onGetClientRecentActivities, onGetClientUpcomingActivities, loading } = this.props;
    onGetClientLists(localStorage.getItem('userId'));
    onGetClientRecentActivities(localStorage.getItem('userId'));
    onGetClientUpcomingActivities(localStorage.getItem('userId'));
    this.fetchClientCountDashboardByAgent();
    this.fetchClientSourceData();
    this.fetchClientCitiesMonthlySalesByOffice();
    this.fetchClientCitiesDistributionByOffice();
    this.fetchClientNotification();
  }
  fetchClientCitiesMonthlySalesByOffice = async () => {
    const agentId = localStorage.getItem("userId");
    const year = "2025";
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Client/clientCitiesMonthlySalesByOffice?agentId=${agentId}&year=${year}`;

    try {
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

      if (response.data) {
        const { months, counts } = response.data;
        this.setState({
          barchartdata: {
            series: [{ name: "Clients", data: counts }],
            options: {
              chart: { type: "bar", toolbar: { show: false } },
              plotOptions: { bar: { horizontal: false, columnWidth: "50%" } },
              dataLabels: { enabled: false },
              colors: ["#195772"],
              grid: { borderColor: "#f1f1f1" },
              xaxis: { categories: months },
              height: 200,
              fill: { opacity: 1 },
              tooltip: { y: { formatter: (val) => `${val} Clients` } },
            },
          },
        });
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  };
  fetchClientCountDashboardByAgent = async () => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const str = `Bearer ${token}`;

    try {
      const response = await axios.get(`${API_URL}Client/getClientCountDashboardByAgent`, {
        params: {
          agentId: localStorage.getItem("userId"),
          year: 2025
        },
        headers: { Authorization: str }
      });

      if (response.data && Array.isArray(response.data)) {
        const totalClient = response.data.find(item => item.sources === "Total")?.counts || 0;
        const monthClient = response.data.find(item => item.sources === "Month")?.counts || 0;
        const transactionClient = response.data.find(item => item.sources === "Transaction")?.counts || 0;
        const ClientConversion = response.data.find(item => item.sources === "ClientConversion")?.counts || 0;

        this.setState(prevState => ({
          reports: prevState.reports.map(report => {
            if (report.title === "Active clients") return { ...report, description: totalClient };
            if (report.title === "Closing(s) this month") return { ...report, description: monthClient };
            //if (report.title === "Performance / Goals") return { ...report, description: transactionClient };
            if (report.title === "Lead to client conversion") return { ...report, description: ClientConversion };
            return report;
          })
        }));
      }
    } catch (error) {
      console.error("Error fetching lead counts:", error);
    }
  };

  fetchClientSourceData = async () => {
    const agentId = localStorage.getItem("userId");
    const year = "2025";
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Client/getClientSourceDashboardByAgent?agentId=${agentId}&year=${year}`;

    try {
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      if (response.data && Array.isArray(response.data)) {

        const sources = response.data.map(item => item.sources);
        const counts = response.data.map(item => parseInt(item.counts));
        this.setState({
          leadSourceData: {
            series: counts,
            options: {
              chart: { type: "pie" },
              labels: sources,
              colors: ["#004aad", "#ffbd59", "#cb6ce6", "#ff6d4d", "#14891c"],
              legend: {
                show: true,
                position: "bottom",
                horizontalAlign: "center",
                verticalAlign: "middle",
                floating: false,
                fontSize: "14px",
                offsetX: 0,
                offsetY: -10,
              },
              responsive: [{ breakpoint: 600, options: { chart: { height: 440 }, legend: { show: false } } }],
            },
          },
        });
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  };


  fetchClientCitiesDistributionByOffice = async () => {
    const agentId = localStorage.getItem("userId");
    const year = "2025";
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Client/clientCitiesDistributionByOffice?agentId=${agentId}&year=${year}`;

    try {
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });

      if (response.data) {
        const { cities, percentages } = response.data;


        const filteredCities = [];
        const filteredPercentages = [];

        cities.forEach((city, index) => {
          if (city.trim()) {
            filteredCities.push(city);
            filteredPercentages.push(percentages[index]);
          }
        });

        this.setState({
          citySourceData: {
            series: filteredPercentages,
            options: {
              chart: { type: "pie" },
              labels: filteredCities,
              colors: ["#004aad", "#ffbd59", "#cb6ce6", "#ff6d4d", "#14891c"],
              legend: {
                show: true,
                position: "bottom",
                horizontalAlign: "center",
                verticalAlign: "middle",
                floating: false,
                fontSize: "14px",
                offsetX: 0,
                offsetY: -10,
              },
              responsive: [{
                breakpoint: 600,
                options: { chart: { height: 440 }, legend: { show: false } }
              }],
            },
          },
        });
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  };

  filterTable = (event) => {
    this.setState({ tableFilter: event.target.value });
  };
  handleSubmitReferalRequestEmail = async (values, { setSubmitting }) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const payload = {
      contactId: values.contactId,
      agentId: values.agentId,
      contactConnectType: 1,
      email: values.email,
      mobile: values.mobile,
      sentOn: values.sentOn,
      subject: values.subject,
      notes: values.notes,
    };

    toast.loading('Please wait...');

    try {
      const response = await axios.post(`${API_URL}ContactConnect`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.dismiss();
        toast.success("Referral request sent successfully!");
        this.setState({ isReferral: false });
      } else {
        toast.dismiss();
        toast.error("Failed to submit referral request.");
      }
    } catch (error) {
      console.error("Error submitting referral request:", error);

    } finally {
      setSubmitting(false);
    }
  };

  handleSubmitReviewRequestEmail = async (values, { setSubmitting }) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const payload = {
      contactId: values.contactId,
      agentId: values.agentId,
      contactConnectType: 2,
      email: values.email,
      mobile: values.mobile,
      sentOn: values.sentOn,
      subject: values.subject,
      notes: values.notes,
    };

    toast.loading('Please wait...');

    try {
      const response = await axios.post(`${API_URL}ContactConnect`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.dismiss();
        toast.success("Review request sent successfully!");
        this.setState({ isReferral: false });
      } else {
        toast.dismiss();
        toast.error("Failed to submit review request.");
      }
    } catch (error) {
      console.error("Error submitting review request:", error);

    } finally {
      setSubmitting(false);
    }
  };

  handleSubmitSurveyRequestEmail = async (values, { setSubmitting }) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const payload = {
      contactId: values.contactId,
      agentId: values.agentId,
      contactConnectType: 3,
      email: values.email,
      mobile: values.mobile,
      sentOn: values.sentOn,
      subject: values.subject,
      notes: values.notes,
    };

    toast.loading('Please wait...');

    try {
      const response = await axios.post(`${API_URL}ContactConnect`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.dismiss();
        toast.success("Survey request sent successfully!");
        this.setState({ isReferral: false });
      } else {
        toast.dismiss();
        toast.error("Failed to submit survey request.");
      }
    } catch (error) {
      console.error("Error submitting survey request:", error);

    } finally {
      setSubmitting(false);
    }
  };
  fetchSurveyHistory = (ContactId) => {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const agentId = localStorage.getItem('userId');
    const params = {
      agentId: agentId,
      clientId: ContactId
    };

    axios.get(`${API_URL}ContactSurvey/allforclient`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    }).then((res) => {
      const allSurveys = res.data || '';
      this.setState({ allSurveys: allSurveys, isLoading: false });
    })
      .catch((error) => {
        console.error("Error fetching  content:", error);
        this.setState({ isLoading: false });
      });
  };
  isMidnight = (value) => {
    if (!value) return true;

    // Case 1: plain string like "00:00"
    if (typeof value === 'string' && value.trim() === '00:00') {
      return true;
    }

    // Case 2: full ISO string or Date object
    try {
      const date = new Date(value);
      return date.getHours() === 0 && date.getMinutes() === 0;
    } catch (e) {
      return true; // fallback: treat invalid date as midnight
    }
  };
  fetchClientNotification() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      ForId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}Notification/allAgent`, { headers, params })
      .then((response) => {
        this.setState({ clientnotificationsData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchMonthClosings() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      agentId: localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ClientEngagement/allbyagentformonth`, { headers, params })
      .then((response) => {
        this.setState({ closingMonths: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  getBuyerType = (type) => {
    if (type == 1)
      return 'Rent';
    else if (type == 2)
      return 'Purchase';

  }

  getSellerType = (type) => {
    if (type == 1)
      return 'Sell';
    else if (type == 2)
      return 'Lease';

  }
    sendLogin = async (rowData) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    const payload = {
      uId: rowData.id,
      userName: rowData.prefferedEmail,
      updatedBy: parseInt(localStorage.getItem('userId'))
    };

    toast.loading('Please wait...');

    try {
      const response = await axios.post(`${API_URL}ClientExt/UpdateUserLogin`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success) {
        toast.dismiss();
        toast.success("Sent successfully!");
       
      } else {
        toast.dismiss();
        toast.error("Failed to sending login details.");
      }
    } catch (error) {
      console.error("Error submitting request:", error);

    }
  };
  render() {
    const { clientLists, uactivities, loading, userdetail, isResponsive } = this.props;
    const { clientRef } = this.state;
    const clientnotificationsData = this.state.clientnotificationsData || [];
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'day').startOf('day');
    const sevenDaysAgo = moment().subtract(7, 'days').startOf('day');

    const filteredNotifications = clientnotificationsData.filter(notification => {
      const notifDate = moment(notification.notificationDate);

      if (this.state.activeTab === '1') {
        return notifDate.isSame(today, 'day');
      } else if (this.state.activeTab === '2') {
        return notifDate.isSame(yesterday, 'day');
      } else if (this.state.activeTab === '3') {
        return notifDate.isBetween(sevenDaysAgo, today.clone().endOf('day'), 'day', '[]');
      }

      return true;
    });
    const typeOptions = [
      { label: "Buyer", value: 1 },
      { label: "Seller", value: 2 },
      { label: "Pre-Construction", value: 4 }
    ];

    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="">
            <Row className="project-header">
              <Col xl="7">
                <Breadcrumbs
                  title={this.props.t("Clients")}
                  breadcrumbItem={this.props.t("Client Dashboard")}
                />
              </Col>
              <Col xl="5">
                <div className="pt-2 float-end mt-2">

                  <div className="">

                    <RsAdNewV2 to="#" onClick={this.toggleAddNew} className="border-right" iconClass="bx bx-plus-medical">Add new</RsAdNewV2>
                    {!isResponsive && (
                      <RsAdNewV2 to="/clients/import-client" className="" iconClass=" bx bx-upload font-size-18">Import clients</RsAdNewV2>
                    )}

                  </div>

                </div>

              </Col>
            </Row>
            <div className="d-flex justify-content-center gap-3 flex-wrap bg-yellow">
              {this.state.reports.map((report, key) => (

                <div
                  key={key}
                  className="flex-grow-1 flex-shrink-0"
                  style={{ flexBasis: "calc(20% - 1rem)", cursor: report.title === "Closing(s) this month" ? 'pointer' : 'default' }}
                  onClick={report.title === "Closing(s) this month" ? this.toggleClosing : undefined}
                >
                  <RsCardImgv4 title={report.title} description={report.description} iconClass={report.iconClass} userdetail={userdetail} />

                </div>
              ))}

            </div>
            <Row>

            </Row>

            <Row>


              <Col xl="3" className="d-flex">
                <Card className="border-full mt-4 w-100">
                  <CardBody className="d-flex flex-column">

                    {this.state.leadSourceData && <RSPieChart filter="" title="Sources" {...this.state.leadSourceData} />}


                  </CardBody>
                </Card>
              </Col>
              <Col xl="6" className="d-flex">
                <Card className="border-full mt-4 w-100">
                  <CardBody className="d-flex flex-column">

                    {this.state.barchartdata && <RSBarChart filter="" title="Monthly client generation" {...this.state.barchartdata} />}



                  </CardBody>
                </Card>
              </Col>
              <Col xl="3" className="d-flex">
                <Card className="border-full mt-4 w-100">
                  <CardBody className="d-flex flex-column">

                    {this.state.citySourceData && <RSPieChart filter="" title="Client/Cities distribution" {...this.state.citySourceData} />}


                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col sm="6" className="d-flex">
                <Card className="border-full mt-4 w-100">
                  <CardBody className="d-flex flex-column">
                    <h5 className="card-title"><img src={upcomingImg} width={32} /> Upcoming Activities</h5>

                    <div className="table-wrapper table-wrapper-scroll">


                      <div className="table-wrapper table-wrapper-scroll">

                        {(() => {

                          const openRow = this.state.openRow;
                          const toggleRow = (id) => this.setState({ openRow: openRow === id ? null : id });

                          return (
                            <table className="table mb-0 table">
                              <thead>
                                {isResponsive ? (
                                  <tr>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Client</th>
                                  </tr>
                                ) : (
                                  <tr>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Client Name</th>
                                    <th>Type</th>

                                  </tr>
                                )}
                              </thead>

                              <tbody>
                                {uactivities && uactivities.length > 0 ? (
                                  uactivities.map((uactivitie, index) =>
                                    isResponsive ? (
                                      <React.Fragment key={index}>
                                        {/* Collapsed row (mobile) */}
                                        <tr
                                          onClick={() => toggleRow(index)}
                                          style={{
                                            cursor: "pointer",
                                            background: openRow === index ? "#f8f9fa" : "transparent",
                                          }}
                                        >
                                          <td>
                                            <Moment format="D MMM YY">{uactivitie?.activityDate}</Moment>
                                          </td>
                                          <td>{uactivitie?.activityRefStartTime || ""}</td>
                                          <td>
                                            {uactivitie?.clientName}
                                            <i
                                              className={`bx ${openRow === index ? "bx-chevron-up" : "bx-chevron-down"
                                                } float-end`}
                                            ></i>
                                          </td>
                                        </tr>

                                        {/* Expanded row */}
                                        {openRow === index && (
                                          <tr>
                                            <td colSpan="2" className="bg-light p-2">
                                              <div>
                                                <strong>Time:</strong> {uactivitie?.activityRefStartTime || "-"}
                                              </div>
                                              <div>
                                                <strong>Type:</strong> {uactivitie?.activityType}
                                              </div>

                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    ) : (
                                      // Desktop normal row
                                      <tr key={index}>
                                        <td>
                                          <Moment format="D MMM YY">{uactivitie?.activityDate}</Moment>
                                        </td>
                                        <td>{uactivitie?.activityRefStartTime || ""}</td>
                                        <td>{uactivitie?.clientName}</td>
                                        <td>{uactivitie?.activityType}</td>
                                        <td>
                                          <RsLink className="btn btn-action btn-sm" iconClass="bx bx-link-external">
                                            View
                                          </RsLink>
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={isResponsive ? 2 : 5} style={{ textAlign: "center" }}>
                                      No activities found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          );
                        })()}

                      </div>

                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col sm="6" className="d-flex">
                <Card className="border-full mt-4 w-100">
                  <CardBody className="d-flex flex-column">
                    <h5 className="card-title w-100"><img src={interactionImg} width={32} /> Client Interaction
                      <span className="float-end">
                        {isResponsive ? (
                          <select
                            className="form-select"
                            value={this.state.activeTab}
                            onChange={(e) => {
                              const val = e.target.value;
                              this.toggle(val);
                              //this.fetchLeadActivity(val === "1" ? 1 : val === "2" ? 2 : 7);
                            }}
                          >
                            <option value="1">{this.props.t("Today")}</option>
                            <option value="2">{this.props.t("Yesterday")}</option>
                            <option value="3">{this.props.t("Past 7 Days")}</option>
                          </select>
                        ) : (
                          <Nav className="projectTab actTabs" variant="tabs">
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab === "1",
                                })}
                                onClick={() => {
                                  this.toggle("1");

                                }}
                              >
                                <span className="">
                                  {this.props.t("Today")}
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab === "2",
                                })}
                                onClick={() => {
                                  this.toggle("2");

                                }}
                              >
                                <span className="">
                                  {this.props.t("Yesterday")}
                                </span>
                              </NavLink>

                            </NavItem>
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: this.state.activeTab === "3",
                                })}
                                onClick={() => {
                                  this.toggle("3");

                                }}
                              >
                                <span className="">
                                  {this.props.t("Past 7 Days")}
                                </span>
                              </NavLink>

                            </NavItem>

                          </Nav>
                        )}


                      </span>
                    </h5>
                    <div className="table-wrapper table-wrapper-scroll">
                      <table className="table mb-0 table">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Note</th>


                          </tr>
                        </thead>
                        <tbody>
                          {filteredNotifications.length > 0 ? (
                            filteredNotifications.map((cnotification, index) => (
                              <tr key={index}>
                                <td><Moment format="D MMM YY">{cnotification.notificationDate}</Moment></td>
                                <td>{cnotification.notificationText}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2" className="text-center">No interactions found</td>
                            </tr>
                          )}


                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>
              </Col>


            </Row>




            <Row>
              <Col lg="12">
                <Card className="border-full mt-4">
                  <CardHeader>
                    <div className="row">
                      <div className="col-sm-8">
                        <ClientPageMenu isResponsive={isResponsive} />
                      </div>
                     <div className="col-sm-4">
                        <div className="input-group">

                          <Input type="text" className="form-control search-bx" id="autoSizingInput"
                            value={this.state.tableFilter}
                            onInput={this.filterTable}
                            placeholder="Search By Name, Phone, Email" />
                          {this.state.tableFilter && (
                            <button
                              className="btn btn-clear position-absolute"
                              style={{
                                right: "40px",
                                top: "48%",
                                transform: "translateY(-50%)",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                              }}
                              onClick={() => this.setState({ tableFilter: "" })}
                            >
                              ✖
                            </button>
                          )}

                          <span className="input-group-text search-btn" id="basic-addon1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                            </svg>
                          </span>
                        </div>
                      </div> 
                    </div>


                  </CardHeader>
                  <CardBody>

                    <h5 className="card-title">Active Clients</h5>

                    <div className="row">

                      <div className="col-sm-4"></div>

                      <div className="col-sm-4 mb20">


                      </div>


                    </div>
                    <div className="clearfix"></div>

                    {isResponsive ? (
                      <DataTable
                        className=""
                        ref={this.dt}
                        value={clientLists}
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        globalFilter={this.state.tableFilter}
                        responsiveLayout="stack"
                        expandedRows={this.state.expandedRows}
                        onRowToggle={(e) => this.setState({ expandedRows: e.data })}

                        rowExpansionTemplate={(rowData) => (
                          <table className="table table-bordered mb-0">
                            <tbody>
                              <tr>
                                <th>Email</th>
                                <td>{rowData.prefferedEmail || "N/A"}</td>
                              </tr>
                              <tr>
                                <th>Phone</th>
                                <td>{rowData.primaryContact?.cContact?.mobile || "N/A"}</td>
                              </tr>
                              <tr>
                                <th>Type</th>
                                <td>
                                  {rowData.clientTypes?.length
                                    ? rowData.clientTypes.map(ct => ct.clientTypeTitle).join(", ")
                                    : "N/A"}
                                </td>
                              </tr>
                              <tr>
                                <th>Status</th>
                                <td>{rowData.isActive ? "Active" : "Inactive"}</td>
                              </tr>
                              <tr>
                                <th>Last Login</th>
                                <td>{rowData.lastLogin ? <Moment format="DD MMM YYYY">{rowData.lastLogin}</Moment> : "-"}</td>
                              </tr>
                            </tbody>
                          </table>
                        )}
                      >


                        <Column expander style={{ width: "3em" }} />
                         <Column
                          header="#"
                          body={(rowData, options) => options.rowIndex + 1}
                          style={{ width: '60px' }}
                        /> 

                        <Column
                          header="Name"
                          body={(rowData) => (
                            <Link to={`/clients/dashbord/${rowData.id}/${rowData.clientId}`}>
                              {rowData.firstName} {rowData.lastName}
                            </Link>
                          )}
                        />
                        {/* <Column
    header="Date"
    body={(rowData) => <Moment format="DD MMM YYYY">{rowData.createdDate}</Moment>}
  /> */}
                        <Column
                          header="Phone"
                          body={(rowData) => (
                            <>
                              {rowData.prefferedEmail}
                              <br />
                              {rowData.primaryContact?.cContact?.mobile}
                            </>
                          )}
                        />


                      </DataTable>
                    ) : (
                      <DataTable className="" ref={this.dt} stripedRows value={clientLists} paginator rows={10} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" globalFilter={this.state.tableFilter} tableStyle={{ minWidth: '50rem' }}   >
                         <Column
                          header="#"
                          headerClassName="header-bg-table"
                          body={(rowData, options) => options.rowIndex + 1}
                          style={{ width: '60px' }}
                        /> 
                        <Column headerClassName="header-bg-table" field="createdDate	" header="Date" body={(rowData) => {
                          return <Moment format="DD MMM YYYY">{rowData.createdDate}</Moment>;
                        }}></Column>
                        <Column headerClassName="align-middle header-bg-table" bodyClassName="table-data" field="firstName" header="Name"
                          filter
                          showFilterMatchModes={false}
                          showFilterOperator={false}
                          showAddButton={false}
                          showClearButton={false}
                          body={(rowData) => {
                            return <Link  to={"/clients/dashbord/" + rowData.id + '/' + rowData.clientId}>{rowData.firstName + " " + rowData.lastName}</Link>
                          }}
                        ></Column>

                        <Column
                          headerClassName="header-bg-table"
                          field="primaryContact.cContact.phone"
                          header="Phone"
                          filter
                          showFilterMatchModes={false}
                          showFilterOperator={false}
                          showAddButton={false}
                          showClearButton={false}
                          filterFunction={(value, filter) => {
                            if (!filter) return true;
                            const phone = value.primaryContact?.cContact?.mobile || "";
                            const email = value.prefferedEmail || "";
                            const search = filter.toLowerCase();
                            return phone.toLowerCase().includes(search) || email.toLowerCase().includes(search);
                          }}
                          body={(rowData) => (
                            <>
                              {rowData.prefferedEmail}
                              <br />
                              {rowData.primaryContact.cContact.mobile}
                            </>
                          )}
                        />
                        <Column
                          headerClassName="align-middle header-bg-table"
                          bodyClassName="table-data"
                          header="Type"
                          filter
                          showFilterMatchModes={false}
                          showFilterOperator={false}
                          showAddButton={false}
                          showClearButton={false}
                          filterMatchMode="in"
                          field="clientTypes"
                          filterFunction={(rowData, filter) => {
                            if (!filter || filter.length === 0) return true;

                            // Ensure rowData.clientTypes is an array
                            const typeCodes = Array.isArray(rowData.clientTypes)
                              ? rowData.clientTypes.map(ct => ct.clientTypeCode)
                              : [];

                            // filter can be a single number or array
                            const filterValues = Array.isArray(filter) ? filter : [filter];

                            // return true if any client type matches selected filter(s)
                            return typeCodes.some(code => filterValues.includes(code));
                          }}
                          filterElement={(options) => (
                            <MultiSelect
                              value={options.value || []} // always an array
                              options={typeOptions}
                              onChange={(e) => options.filterApplyCallback(e.value)}
                              placeholder="Select Type"
                              display="chip"
                              className="p-column-filter"
                            />
                          )}
                          body={(rowData) =>
                            rowData.clientTypes?.length ? (
                              <>
                                {rowData.clientTypes.map((ct, index) => (
                                  <span key={index}>
                                    {ct.clientTypeTitle}
                                    {index < rowData.clientTypes.length - 1 && <br />}
                                  </span>
                                ))}
                              </>
                            ) : (
                              "N/A"
                            )
                          }
                        />

                        <Column
                          headerClassName="header-bg-table"
                          field="isActive"
                          header="Status"
                          body={(rowData) => (rowData.isActive ? "Active" : "Inactive")}
                        />
                        <Column
                          headerClassName="header-bg-table"
                          field=""
                          header="Last Login"
                          body={(rowData) => (
                            rowData.lastLogin ? (
                              <Moment format="DD MMM YYYY">{rowData.lastLogin}</Moment>
                            ) : '-'
                          )}
                        />
                        <Column
                          headerClassName="header-bg-table action-header"
                          bodyClassName="table-data"
                          header={
                            <div className="justify-content-end">
                              <RsLink
                                onClick={() => this.dt.current.reset()}
                                iconClass="bx bx-reset"
                                className="btn-light"
                              >
                                Reset all filters
                              </RsLink>
                            </div>
                          }
                          body={(rowData) => (
                            <>
                              <RsLink
                                className="btn btn-action btn-sm"
                                iconClass=""
                                to={"/clients/dashbord/" + rowData.id + '/' + rowData.clientId}
                              >
                                Workspace
                              </RsLink>
                              {/* <ActionRefferal to="#" onClick={() => this.referralCanavas(rowData)} /> */}
                              <RsLink className="btn btn-sm" onClick={() => this.sendLogin(rowData)}  iconClass="" to="#">
                                Send login email
                              </RsLink>
                            </>
                          )}
                        />
                      </DataTable>
                    )}





                  </CardBody>
                </Card>

              </Col>
            </Row>
          </Container>
        </div>
        <Offcanvas
          isOpen={this.state.isAddNew}
          direction="end"
          toggle={this.toggleAddNew}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleAddNew}>
            New Client
          </OffcanvasHeader>
          <OffcanvasBody>
            <ClientCreate toggleAddNew={this.toggleAddNew} />
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isClosing}
          direction="end"
          toggle={this.toggleClosing}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.toggleClosing}>
            Closing(s) this month
          </OffcanvasHeader>
          <OffcanvasBody>
            <div className="table-responsive">
              <table className="table mb-0 table">
                <thead>
                  <tr>
                    <th>Name</th>

                    <th>Type</th>

                    <th>Closing Date</th>


                  </tr>
                </thead>
                <tbody>

                  {this.state.closingMonths && map(this.state.closingMonths, (closingMonth, ukey) => (
                    <React.Fragment key={"_alist_" + ukey}>
                      <tr>
                        <td>
                          <Link to={`/clients/activity/deal/${closingMonth.clientId}/${closingMonth.clientGuid}`}>
                            {closingMonth.contactName}
                          </Link>
                        </td>
                        <td>
                          {closingMonth.isBuyer
                            ? `Buyer ${closingMonth.buyerType ? `- ${this.getBuyerType(closingMonth.buyerType)}` : ""}`
                            : closingMonth.isSeller
                              ? `Seller ${closingMonth.sellerType ? `- ${this.getSellerType(closingMonth.sellerType)}` : ""}`
                              : ""}
                        </td>
                        <td>
                          <Moment format="D MMM YY">{closingMonth.closingDate}</Moment>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3}>
                          <div>
                            {closingMonth.clientDealCheckListsState?.map((condition, index) => (
                              <div className="form-check form-check-inline" key={index}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`condition-${ukey}-${index}`}
                                  checked={condition.status}

                                />
                                <label className="form-check-label" htmlFor={`condition-${ukey}-${index}`}>
                                  {condition.clientDealCheckListTitle || `Condition ${condition.clientDealConditionId}`}
                                </label>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}

                </tbody>
              </table>

            </div>
          </OffcanvasBody>
        </Offcanvas>

        <Offcanvas
          isOpen={this.state.isReferral}
          direction="end"
          toggle={this.referralCanavas}
          style={{ width: 800 }}
        >
          <OffcanvasHeader toggle={this.referralCanavas}>
            Engagement & Support
          </OffcanvasHeader>
          <OffcanvasBody>
            <Nav pills className="navtab-bg nav-justified">

              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "1",
                  })}
                  onClick={() => {
                    this.toggleReff("1");
                  }}
                >
                  Referral Request
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "5",
                  })}
                  onClick={() => {
                    this.toggleReff("5");
                  }}
                >
                  Referrals
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "2",
                  })}
                  onClick={() => {
                    this.toggleReff("2");
                  }}
                >
                  Reviews
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "3",
                  })}
                  onClick={() => {
                    this.toggleReff("3");
                  }}
                >
                  Survey
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: this.state.activeRef === "4",
                  })}
                  onClick={() => {
                    this.toggleReff("4");
                  }}
                >
                  History
                </NavLink>
              </NavItem>

            </Nav>
            <TabContent
              activeTab={this.state.activeRef}
              className="p-3 text-muted"
            >
              <TabPane tabId="1">
                <Formik
                  enableReinitialize={true}
                  initialValues={{

                    contactId: parseInt(clientRef?.id),
                    agentId: parseInt(localStorage.getItem("userId")),
                    contactConnectType: 1,
                    email: clientRef?.email || '',
                    mobile: clientRef?.mobile || '',
                    sentOn: new Date(),
                    subject: this.state.emailContent?.templateEmailSubject || '',
                    notes: this.state.emailContent?.templateEmailBody || '',
                    smsContent: this.state.emailContent?.templateSMSBody || '',


                  }}
                  validationSchema={Yup.object().shape({
                    subject: Yup.string().required(
                      "This is required"
                    )
                  })}

                  onSubmit={this.handleSubmitReferalRequestEmail}
                >
                  {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Row>

                        <Col sm="12">
                          <div className="link-page">
                            <h5>
                              URL: <a target="_blank" rel="noreferrer" href={this.state.emailContent?.hrefLandingPage}>{this.state.emailContent?.hrefLandingPage}</a> <CopyText textToCopy={this.state.emailContent?.hrefLandingPage} />
                            </h5>
                          </div>
                        </Col>
                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="subject">
                              {this.props.t("Subject")}
                            </Label>
                            <SafeField
                              name="subject"
                              type="text"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.subject && touched.subject
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="subject"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>





                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="notes">
                              {this.props.t("Email Content")}
                            </Label>
                            <CKEditor
                              editor={ClassicEditor}
                              data={values.notes}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue('notes', data);
                              }}
                            />
                            <ErrorMessage
                              name="notes"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="smsContent">
                              {this.props.t("SMS Content")}
                            </Label>
                            <SafeField
                              name="smsContent"
                              as="textarea"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.smsContent && touched.smsContent
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="smsContent"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <div className="clearfix"><SaveButton iconClass="bx bx-mail-send">Send</SaveButton></div>

                      </Row>
                    </Form>
                  )}
                </Formik>
              </TabPane>
              <TabPane tabId="2">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    //subject:'',
                    contactId: parseInt(clientRef?.id),
                    agentId: parseInt(localStorage.getItem("userId")),
                    contactConnectType: 2,
                    email: clientRef?.email || '',
                    mobile: clientRef?.mobile || '',
                    sentOn: new Date(),
                    subject: this.state.reviewemailContent?.templateEmailSubject || '',
                    notes: this.state.reviewemailContent?.templateEmailBody || '',
                    reviewsmsContent: this.state.reviewemailContent?.templateSMSBody || '',


                  }}
                  validationSchema={Yup.object().shape({
                    subject: Yup.string().required(
                      "This is required"
                    )
                  })}

                  onSubmit={this.handleSubmitReviewRequestEmail}
                >
                  {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Row>


                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="subject">
                              {this.props.t("Subject")}
                            </Label>
                            <SafeField
                              name="subject"
                              type="text"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.subject && touched.subject
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="subject"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>





                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="notes">
                              {this.props.t("Email Content")}
                            </Label>
                            <CKEditor
                              editor={ClassicEditor}
                              data={values.notes}
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue('notes', data);
                              }}
                            />
                            <ErrorMessage
                              name="notes"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col md="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="reviewsmsContent">
                              {this.props.t("SMS Content")}
                            </Label>
                            <SafeField
                              name="reviewsmsContent"
                              as="textarea"
                              onChange={handleChange}
                              className={
                                "form-control" +
                                (errors.reviewsmsContent && touched.reviewsmsContent
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="reviewsmsContent"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <div className="clearfix"><SaveButton iconClass="bx bx-mail-send">Send</SaveButton></div>

                      </Row>
                    </Form>
                  )}
                </Formik>
              </TabPane>
              <TabPane tabId="3">
                {this.state.allSurveys?.length > 0 ? (

                  <>
                    <table className="table">
                      <tbody>
                        <tr>
                          <th style={{ width: '30%' }}>Submitted Date</th>
                          <td><Moment format="D MMM YY">{this.state.allSurveys[0]?.addedOn}</Moment></td>
                        </tr>

                        <tr>
                          <th style={{ width: '30%' }}>Overall, how statified were you?</th>
                          <td>{this.state.allSurveys[0]?.howSatisfied}</td>
                        </tr>

                        <tr>
                          <th>What did you like most about the experience?</th>
                          <td>{this.state.allSurveys[0]?.mostLiked}</td>
                        </tr>
                        <tr>
                          <th>What could we improve?</th>
                          <td>{this.state.allSurveys[0]?.whatNeedToImprove}</td>
                        </tr>

                        <tr>
                          <th>Would you work with us again?</th>
                          <td>{this.state.allSurveys[0]?.workWithUsAgain}</td>
                        </tr>

                        <tr>
                          <th>Can we contact you about your feedback</th>
                          <td>{this.state.allSurveys[0]?.canConnectForFeedback}</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                ) : (
                  <>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        //subject:'',
                        contactId: parseInt(clientRef?.id),
                        agentId: parseInt(localStorage.getItem("userId")),
                        contactConnectType: 3,
                        email: clientRef?.email || '',
                        mobile: clientRef?.mobile || '',
                        sentOn: new Date(),
                        subject: this.state.surveyemailContent?.templateEmailSubject || '',
                        notes: this.state.surveyemailContent?.templateEmailBody || '',
                        reviewsmsContent: this.state.surveyemailContent?.templateSMSBody || '',


                      }}
                      validationSchema={Yup.object().shape({
                        subject: Yup.string().required(
                          "This is required"
                        )
                      })}

                      onSubmit={this.handleSubmitSurveyRequestEmail}
                    >
                      {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >
                          <Row>
                            <Col sm="12">
                              <div className="link-page">
                                <h5>
                                  URL: <a target="_blank" rel="noreferrer" href={this.state.surveyemailContent?.hrefLandingPage}>{this.state.surveyemailContent?.hrefLandingPage}</a> <CopyText textToCopy={this.state.emailContent?.hrefLandingPage} />
                                </h5>
                              </div>
                            </Col>

                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="subject">
                                  {this.props.t("Subject")}
                                </Label>
                                <SafeField
                                  name="subject"
                                  type="text"
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.subject && touched.subject
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="subject"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>





                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="notes">
                                  {this.props.t("Email Content")}
                                </Label>
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={values.notes}
                                  onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setFieldValue('notes', data);
                                  }}
                                />
                                <ErrorMessage
                                  name="notes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>

                            <Col md="12">
                              <FormGroup className="mb-3">
                                <Label htmlFor="reviewsmsContent">
                                  {this.props.t("SMS Content")}
                                </Label>
                                <SafeField
                                  name="reviewsmsContent"
                                  as="textarea"
                                  onChange={handleChange}
                                  className={
                                    "form-control" +
                                    (errors.reviewsmsContent && touched.reviewsmsContent
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <ErrorMessage
                                  name="reviewsmsContent"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <div className="clearfix"><SaveButton iconClass="bx bx-mail-send">Send</SaveButton></div>

                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </>
                )}

              </TabPane>
              <TabPane tabId="4">
                <ul className="verti-timeline list-unstyled">
                  {this.state.allHistory && this.state.allHistory.length > 0 && (
                    this.state.allHistory.map((history, index) => (
                      <li key={index} className="event-list eventlist">
                        <div className="event-timeline-dot"></div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="font-size-14">
                              <Moment format="D MMM YY">{history.sentOn}</Moment>

                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14">
                              {history.subject || 'N/A'}
                            </h5>
                          </div>
                        </div>

                      </li>
                    ))
                  )}
                </ul>
              </TabPane>
              <TabPane tabId="5">
                <ul className="verti-timeline list-unstyled">
                  {this.state.allreferrals && this.state.allreferrals.length > 0 && (
                    this.state.allreferrals.map((referral, index) => (
                      <li key={index} className="event-list eventlist">
                        <div className="event-timeline-dot"></div>
                        <div className="d-flex">
                          <div className="flex-shrink-0 me-3">
                            <h5 className="font-size-14">
                              <Moment format="D MMM YY">{referral.submittedDate}</Moment>

                            </h5>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="font-size-14">
                              {referral.firstName + " " + referral.lastName || 'N/A'}
                            </h5>
                          </div>
                        </div>
                        <div className="exNote">
                          Phone : {referral.mobile || 'N/A'}
                        </div>
                      </li>
                    ))
                  )}
                </ul>
              </TabPane>

            </TabContent>

          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }
}
Client.propTypes = {
  t: PropTypes.any,
  onGetClientLists: PropTypes.func,
  clientLists: PropTypes.array,
  onGetClientRecentActivities: PropTypes.func,
  onGetClientUpcomingActivities: PropTypes.func,
  uactivities: PropTypes.array,
  loading: PropTypes.object,
  userdetail: PropTypes.object,
  isResponsive: PropTypes.object

}
const mapStateToProps = ({ Clients }) => (
  {
    clientLists: Clients.clientLists,
    uactivities: Clients.uactivities,
    ractivities: Clients.ractivities,
    loading: Clients.loading

  })
const mapDispatchToProps = dispatch => ({
  onGetClientLists: agentID => dispatch(getClientList(agentID)),
  onGetClientRecentActivities: agentId => dispatch(getClientRecentActivities(agentId)),
  onGetClientUpcomingActivities: agentId => dispatch(getClientUpcomingActivities(agentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Client))
